import React, { useEffect, useMemo, useState, useContext } from "react";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import Loader from "../../../../components/Loader/Loader";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import moment from "moment";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../../common/Constant";
import CommonDatePicker from "../../../../components/DatePicker/CommonDatePicker";
import axios from "axios";
import config from "../../../../config/config";
import CommonMatrialReactTable from "../../../../components/Datatable/CommonMatrialReactTable";
import { IoIosMailOpen } from "react-icons/io";
import CommonDatePickerSelect from "../../../../components/DatePicker/CommonDatePickerSelect";
import { toastError, toastSuccess } from "../../../../common/Toast";
import { Box } from "@mui/material";
import { AppContext } from "../../../../context/AppContext";
import CurrencySymbols from "../../../../common/CurrencySymbol";

const DriverDailySheet = () => {
  const { CurrencySymbol, FractionDigits, dateFormate } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  //   const today = new Date();
  //    let dates = moment(today).format("yyyy-mm-dd")
  const Navigate = useNavigate(); 
  const [selecteddate, setselecteddate] = useState(moment().format());
  const [startDate, setStartdate] = useState("");
  const [endDate, setEnddate] = useState("");
  const [salesTypeID, setSalesTypeID] = useState(1);
  const [tableData, setTableData] = useState([]);
  const [saletype, setSaletype] = useState([]);
  const [datafetch, setdatafetch] = useState(false);
  const [isRoutesdropdown, setRoutesdropdown] = useState([]);
  const [usersDropdown, setUsersDropdown] = useState([]);
  const token = localStorage.getItem("Token");
  const ID = localStorage.getItem("ID");
  const location = localStorage.getItem("Location");

  const [deliveryMethodOption, setDeliveryMethodOption] = useState([]);
  const [deliveryMethodId, setDeliveryMethodId] = useState(1);
  const [selectedRoute, setSelectedRoute] = useState("");
  const [assigns, setassign] = useState("All");
  const [employeeid, setempolyee] = useState(0);
  const [employeeFilterId, setEmpolyeeFilterId] = useState(0);

  const [custoptions, setCustOptions] = useState([]);
  const [customerID, setCustomerID] = useState(0);

  const [rowSelectData, setRowSelectData] = useState([]);
  const [rowSelection, setRowSelection] = useState({});

  const [updateToTaskId, setUpdateToTaskId] = useState(0);
  const [taskIdsOptions, setTaskIdsOptions] = useState([]);
  const [employeeUpsertId, setEmployeeUpsertId] = useState(0);

  useEffect(() => {
    const result = Object.keys(rowSelection).map(Number);
    setRowSelectData(result);
    if (result.length === 0) {
      setEmployeeUpsertId(0);
      setUpdateToTaskId(0);
    }
  }, [rowSelection]);

  console.log(selectedRoute, "78787878");

  const columns = useMemo(
    () => [
      {
        header: "Date",
        accessorKey: "Date",
        Cell: ({ row }) => moment(row.original.Date).format(`${dateFormate.toUpperCase()} hh:mm:ss a`),
        // size: 120,
      },
      {
        header: "Sale Type",
        accessorKey: "SaleType",
        // size: 120,
      },
      {
        header: "Invoice #",
        accessorKey: "InvoiceNo",
        Cell: ({ row }) => (
          <Box
            component="span"
            sx={(theme) => ({
              borderRadius: "0.3rem",
              color: "#343f62",
              maxWidth: "18ch",
              fontWeight: "700",
              textDecoration: "underline",
              textUnderlineOffset: "3px",
              p: "0.3rem",
              cursor: "pointer",
            })}
            onClick={() =>
              Navigate(`/sales-receipt/${row.original.InvoiceNo}`, "_blank")
            }
          >
            {row.original.InvoiceNo}
          </Box>
        ),
        // size: 150,
      },
      {
        header: "Company Name",
        accessorKey: "CompanyName",
        // size: 120,
      },
      {
        header: "Total",
        accessorKey: "Total",
        // Cell: ({ row }) =>
        //   `$${Number(row.original.Total).toLocaleString("en-US", {
        //     minimumFractionDigits: 2,
        //     maximumFractionDigits: 2,
        //   })}`,
        Cell: ({ row }) =>
          row.original.Total > 0 
            ? `${ CurrencySymbols(
              Number(row.original.Total),
              { CurrencySymbol },
              FractionDigits)}`
            // ? `$${Number(row.original.Total).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
            : `${CurrencySymbol}0.00`,
        // size: 80,
      },
      {
        header: "Task status",
        accessorKey: "TaskStatus",
        // size: 80,
      },
      {
        header: "Assigned To",
        accessorKey: "AssignedTo",
        // size: 80,
      },
      {
        header: "Task ID",
        accessorKey: "TaskId",
        Cell: ({ row }) =>
          row.original.TaskId > 0 ? (
            <Box
              component="span"
              sx={(theme) => ({
                borderRadius: "0.3rem",
                color: "#343f62",
                maxWidth: "18ch",
                fontWeight: "700",
                textDecoration: "underline",
                textUnderlineOffset: "3px",
                p: "0.3rem",
                cursor: "pointer",
              })}
              onClick={() =>
                Navigate(
                  `/Driver-Task-Receipt/${row.original.TaskId}`,
                  "_blank"
                )
              }
            >
              {row.original.TaskId}
            </Box>
          ) : (
            "--"
          ),

        // size: 80,
      },
      {
        header: "Delivery Status",
        accessorKey: "DeliveryStatus",
        // size: 80,
      },
      {
        header: "Route",
        accessorKey: "Route",
        // size: 80,
      },
      {
        header: "REP",
        accessorKey: "REP",
        // size: 80,
      },
      {
        header: "Address",
        accessorKey: "FullAddress",
        // size: 80,
      },
    ],
    []
  );

  const handelChnageTaskToEmployee = (empId) => {
    setEmployeeUpsertId(empId);
    if (empId != 0) {
      axios
        .get(
          `${config.salesconfigBaseUrl}/sales/drivertaskslist?employeeId=${empId}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          console.log("usersdropdown", res);

          const maindata = res.data.ResponseData.map((u, i) => {
            return {
              label: `TaskID: (${u.ID}) Count: (${u.InvoiceCount}) Driver: ${u.AssignTo} (Date: ${u.CreatedDate})`,
              value: u.ID,
            };
          });
          setUpdateToTaskId(0);
          setTaskIdsOptions(maindata);
        });
    } else {
      setUpdateToTaskId(0);
    }
  };

  const handleChangeCustomEndingDate = (value) => {
    console.log(value, "8858");
    setselecteddate(value);
  };

  const handleChangeSalesType = (event) => {
    setSalesTypeID(event?.value ? event?.value : 0);
  };

  const callbackStartDate = (startDate) => {
    setStartdate(startDate);
  };
  const callbackEndDate = (endDate) => {
    setEnddate(endDate);
  };

  useEffect(() => {
    axios
      .get(`${config.salesconfigBaseUrl}/sales/saletype`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((response) => {
        setSaletype(response.data.ResponseData);
        console.log(response.data.ResponseData, "===> setSaletype");
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(`${config.customersBaseUrl}/customers/Routesdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          'Access-Control-Allow-Origin': "*",
          Authorization: token,
        },
      })
      .then((res) => setRoutesdropdown(res.data.ResponseData))
      .catch((error) => console.log(error));

    axios
      .get(`${config.employeesBaseUrl}/employees/usersdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("usersdropdown", res);
        setUsersDropdown(res.data.ResponseData);
        // setLoading(false);

        return res;
      });

    // Delivery Method drop down
    axios
      .get(`${config.deliveriesBaseUrl}/deliveries/deliverymethodlist`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          'Access-Control-Allow-Origin': "*",
          Authorization: token,
        },
      })
      .then((response) => {
        const deliveryData = response.data.ResponseData?.map((el) => {
          return { label: el.Name, value: el.ID };
        });
        setDeliveryMethodOption(deliveryData);
        console.log(response.data.ResponseData, "=====deliverymethodlist");
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(`${config.customersBaseUrl}/customers/customerdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          'Access-Control-Allow-Origin': "*",
          Authorization: token,
        },
      })
      .then((response) => {
        setCustOptions(response.data.ResponseData);
        console.log(response.data.ResponseData, "===> setCustOptions");
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    if (endDate != "" || startDate != "") {
      axios
        .get(
          `${config.salesconfigBaseUrl}/sales/driverdailysheet?startdate=${startDate}&endDate=${endDate}&salestypeid=${salesTypeID}&deliverymethodid=${deliveryMethodId}&locationid=${location}&selectedRoute=${selectedRoute}&assigns=${assigns}&customerID=${customerID}&employeeId=${employeeFilterId}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((response) => {
          setTableData(response.data.ResponseData);
          console.log(response.data.ResponseData, "===> setSaletype");
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [
    salesTypeID,
    deliveryMethodId,
    startDate,
    endDate,
    selectedRoute,
    assigns,
    customerID,
    employeeFilterId,
  ]);

  console.log(salesTypeID, deliveryMethodId, startDate, endDate, "checkdate");

  const customerDropDown = custoptions.map((option) => ({
    value: option.Id,
    label: option.CompanyName,
    address: option.Address1,
    email: option.Email,
  }));

  let salesTypeDropdownOption = [];
  const SalesTypeDropdown = saletype.map((u, i) => {
    salesTypeDropdownOption[i] = { label: u.SalesType, value: u.ID };
  });

  let isRoutesdropdownOption = [];
  const categorytypeDropdown = isRoutesdropdown.map((u, i) => {
    isRoutesdropdownOption[i] = {
      label: u.RouteName,
      value: u.ID,
    };
  });

  const assign = [
    { label: "All", value: 0 },
    { label: "Unassigned", value: 1 },
    { label: "Assigned", value: 2 },
  ];

  let usersDropdownOption = [];
  const userDropdown = usersDropdown.map((u, i) => {
    usersDropdownOption[i] = { label: u.Name, value: u.Id };
  });

  const handleGetSelectedRows = () => {
    setdatafetch((t) => !t);
  };

  const dataget = (data) => {
    console.log(data, employeeid, "41787");

    if (data.length == 0) {
      //toastError("Select data for assign Driver");
      return;
    }

    const Itemobj = {};

    Itemobj.Driveritems = data;
    let itemjsonstring = JSON.stringify(Itemobj);

    let SalesData = {
      xmldriveritems: itemjsonstring,
      employeid: employeeid,
      loginUserId: ID,
      location: location,
      id: 0,
    };

    setTimeout(() => {
      setLoading(true);
      axios
        .post(`${config.salesconfigBaseUrl}/sales/DriverTaskData`, SalesData, {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            'Access-Control-Allow-Origin': "*",
            Authorization: token,
          },
        })
        .then((res) => {
          if (res.data.ResponseCode == "SUCCESS") {
            Navigate("/Driver-Task-List");
          }
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    }, 500);
  };

  const handelUpdatetask = () => {
    const updateObject = {
      taskID: 0,
      employeeId: employeeUpsertId,
      movedToTaskId: updateToTaskId,
      SalesList: rowSelectData.join(","), // now we pass sale id
      loginuserId: ID,
      location: location,
      model: "driversheet",
    };

    console.log(updateObject, "updateObject");
    // return;
    axios
      .post(
        `${config.salesconfigBaseUrl}/sales/drivertaskUpdate`,
        updateObject,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        if (response.data.ResponseCode === "SUCCESS") {
          toastSuccess(response.data.ResponseMessage);
          setUpdateToTaskId(0);
          setEmployeeUpsertId(0);
          setRowSelection({});
          setRowSelectData([]);
          Navigate("/Driver-Task-List");
        } else {
          toastError(response.data.ResponseMessage);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">Inventory: Items</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "11px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item" style={{ marginLeft: "11px" }}>
                  <Link to="/Driver-Daily-sheet">Driver Daily Sheet</Link>
                </li>
                <li className="breadcrumb-item active">Driver Daily Sheet</li>
              </ul>
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-3">
                  {" "}
                  Sales Type:
                  <Select
                    onChange={(event) => {
                      handleChangeSalesType(event);
                    }}
                    value={salesTypeDropdownOption?.find(
                      (el) => el.value == salesTypeID
                    )}
                    options={salesTypeDropdownOption}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    className="custom-search-select mt-1"
                  />{" "}
                </div>
                <div className="col-md-3">
                  {" "}
                  Delivery Menthod:
                  <Select
                    options={deliveryMethodOption}
                    className="custom-search-select mt-1"
                    value={deliveryMethodOption.find(
                      (el) => el.value === deliveryMethodId
                    )}
                    isClearable={true}
                    onChange={(event) =>
                      setDeliveryMethodId(event?.value ? event?.value : 0)
                    }
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  />
                </div>

                <div className="col-md-3">
                  {" "}
                  Routes:
                  <Select
                    options={isRoutesdropdownOption}
                    className="custom-search-select mt-1"
                    value={isRoutesdropdownOption.find(
                      (el) => el.label === selectedRoute
                    )}
                    isClearable={true}
                    onChange={(event) =>
                      setSelectedRoute(event?.label ? event?.label : "")
                    }
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  />
                </div>
                <div className="col-md-3">
                  {" "}
                  Task Status:
                  <Select
                    options={assign}
                    className="custom-search-select mt-1"
                    value={assign.find((el) => el.label === assigns)}
                    isClearable={true}
                    onChange={(event) =>
                      setassign(event?.label ? event?.label : "All")
                    }
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  />
                </div>
                <div className="col-md-3">
                  {" "}
                  Customer:
                  <Select
                    onChange={(event) => {
                      setCustomerID(event?.value ? event?.value : 0);
                    }}
                    options={customerDropDown}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    className="custom-search-select mt-1"
                    value={customerDropDown?.find(
                      (el) => el?.value == customerID
                    )}
                  />
                </div>
                <CommonDatePickerSelect
                  callbackEndDate={callbackEndDate}
                  callbackStartDate={callbackStartDate}
                  dateSelectValue={9}
                />
                <div className="col-md-3">
                  {" "}
                  Employee:
                  <Select
                    options={usersDropdownOption}
                    className="custom-search-select mt-1"
                    value={usersDropdownOption.find(
                      (el) => el.value === employeeFilterId
                    )}
                    isClearable={true}
                    onChange={(event) =>
                      setEmpolyeeFilterId(event?.value ? event?.value : 0)
                    }
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-body row">
              <div className="col-md-3">
                Employee:
                <Select
                  options={usersDropdownOption}
                  className="custom-search-select mt-1"
                  value={
                    employeeUpsertId > 0
                      ? usersDropdownOption.find(
                          (el) => el.value === employeeUpsertId
                        )
                      : null
                  }
                  isClearable={true}
                  onChange={(event) =>
                    handelChnageTaskToEmployee(event?.value ? event?.value : 0)
                  }
                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  isDisabled={rowSelectData.length === 0}
                />
              </div>
              <div className="col-md-3">
                Move Task TO:
                <Select
                  options={taskIdsOptions}
                  className="custom-search-select mt-1"
                  value={
                    updateToTaskId > 0
                      ? taskIdsOptions.find((el) => el.value == updateToTaskId)
                      : null
                  }
                  isClearable={true}
                  onChange={(event) =>
                    setUpdateToTaskId(event?.value ? event?.value : 0)
                  }
                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  isDisabled={employeeUpsertId === 0}
                />
              </div>
              <div className="col-md-3">
                {rowSelectData?.length > 0 && (
                  <button
                    className="btn btn-primary btn-sm mt-4"
                    onClick={() => handelUpdatetask()}
                  >
                    {rowSelectData?.length > 0 &&
                    employeeUpsertId === 0 &&
                    updateToTaskId === 0
                      ? "UnAssigned"
                      : employeeUpsertId > 0 && updateToTaskId === 0
                      ? "Create a New Task"
                      : `Assign To ${
                        usersDropdownOption.find(
                            (el) => el.value === employeeUpsertId
                          )?.label
                        }`}
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* <div className="card">
            <div className="card-body row">
              <div className="col-md-3">
                {" "}
                Employee :
                <Select
                  options={usersDropdownOption}
                  className="custom-search-select mt-1"
                  value={usersDropdownOption.find(
                    (el) => el.value === employeeid
                  )}
                  isClearable={true}
                  onChange={(event) =>
                    setempolyee(event?.value ? event?.value : 0)
                  }
                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                />
              </div>
              {employeeid > 0 && (
                <div className="col-md-3" style={{ marginTop: "20px" }}>
                  <button
                    className="btn btn-sm btn-secondary "
                    onClick={handleGetSelectedRows}
                  >
                    Assign Driver
                  </button>
                </div>
              )}
            </div>
          </div> */}

          <div className="card">
            <div className="card-body">
              {/* custom-table-css */}
              <div
                className="table-responsive"
                style={{ position: "relative", zIndex: "0" }}
              >
                <CommonMatrialReactTable
                  MainHeading="Sonar POS"
                  ReportHeading="Driver Daily Sheet"
                  columns={columns}
                  data={tableData}
                  startdate={""}
                  enddate={""}
                  columnGrouping={[]}
                  columnsVisibility={{}}
                  isdriverdailyreport={true}
                  // datafetch={datafetch}
                  // dataget={dataget}
                  setRowSelectData={setRowSelection}
                  state={{
                    rowSelection,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DriverDailySheet;
